export const shutdownIntercom = () => {
  const wnd = window as any;
  if (wnd.Intercom) {
    wnd.Intercom('shutdown');
  } else {
    console.warn('[Newslit] Intercom object not found while shutting down.');
  }
};
